import NotificationsList from './_NotificationsList';

export default NotificationsList;
